import type { ReactNode } from "react";

import type { DragEndEvent, DragStartEvent } from "@/ui-adapters/DndKit";
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  SortableContext,
  sortableKeyboardCoordinates,
  useSensor,
  useSensors,
  verticalListSortingStrategy,
} from "@/ui-adapters/DndKit";

export type DynamicRepeaterDragStartEvent = DragStartEvent;
export type DynamicRepeaterDragEndEvent = DragEndEvent;

interface Props {
  onDragStart: (event: DragStartEvent) => void;
  onDragEnd: (event: DragEndEvent) => void;
  itemIds: string[];
  children: ReactNode;
}

export function DynamicRepeater({ onDragStart, onDragEnd, itemIds, children }: Props): React.ReactNode {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  return (
    <DndContext onDragStart={onDragStart} onDragEnd={onDragEnd} sensors={sensors}>
      <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </DndContext>
  );
}
